/* eslint-disable camelcase */
import dayjs from 'dayjs';

import utcPlugin from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';
import advancedFormatPlugin from 'dayjs/plugin/advancedFormat';
import calendarPlugin from 'dayjs/plugin/calendar';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import duration from 'dayjs/plugin/duration';

dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

dayjs.extend(advancedFormatPlugin);
dayjs.extend(calendarPlugin);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(duration);

export const formatDateToView = 'MM/DD/YYYY hh:mm:ss A z';
export const formatDateToSave = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
export const formatDateToCalendar = 'YYYY-MM-DDTHH:mm:ss.SSS';
export const formatRegularHour = 'hh:mm A';
export const formatDate = 'MM/DD/YYYY';
export const SHORT_DATE_AMPM = 'MM-DD-YY hh:mm:ss A';
export const SHORT_DATE_FORMAT = 'MM/DD/YY HH:MM';
export const US_COMPLETE_A = 'MM/DD/YYYY HH:mm A';
export const US_LONG_A = 'MM/DD/YYYY hh:mm:ss A';
export const US_LONG_AM_PM_A = 'MM-DD-YYYY HH:mm:ss A';
export const US_SHORT_A = 'MM/DD/YY hh:mm:ss A';
export const US_SHORT_DATETIME_DISPLAY = 'MM/DD/YY hh:mm A';

export const CUSTOM_DATE_FORMAT = 'MM-DD-YYYY hh:mm A';
export const YEAR_MONTH_DAY_HOUR_MINUTES_MERIDIEM_FORMAT = 'YYYY-MM-DD h:mm a';
export const YEAR_MONTH_DAY_HOUR_MINUTES_SECONDS_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const SHORT_YEAR_FORMAT_DATE_US = 'MM/DD/YYYY';
export const SHORT_YEAR_FORMAT_DATE = 'YYYY-MM-DD';
export const MONTH_NAME_ABBREVIATED = 'MMM';
export const MONTH_YEAR = 'MM/YYYY';
export const MONTH_YEAR_LONG = 'MMMM YYYY';
export const MONTH_DAY = 'MM/DD';
export const US_SHORT_DATE = 'MM/DD/YY';
export const CHART_LINEAR_TIMESTAMP_FORMAT = 'YYYY/MM/DD H:mm:ss';
export const DAY_MONTH = 'DD/MM';
export const DAY_WITH_ORDINAL = 'Do';
export const FOUR_DIGIT_YEAR = 'YYYY';
export const REGULAR_HOUR = 'LT';
export const HOURS_MINUTES = 'hh:mm';
export const AMPM = 'A';
export const DEFAULT_TIME_ZONE = 'CST';
export const DEFAULT_TIME_ZONE_LONG = 'America/Chicago';
export const TIMEZONE_FORMAT = 'z';
export const DATE_PICKER_FORMAT = 'MM/dd/yyyy h:mm aa';

// Back Formats
export const US_LONG_AM_PM_UI = 'MM/DD/YYYY hh:mm:ss A z'; // applyDateFormat: true
export const ISO8601_SHORT = "yyyy-MM-dd'T'HH:mm:ss'Z'";
export const ISO8601_LONG = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
export const US_LONG = 'MM-dd-yyyy HH:mm:ss a';
export const US_LONG_AM_PM = 'MM-dd-yyyy hh:mm:ss a';
export const US_LONG_AM_PM_UI_FORMAT = 'MM/dd/yyyy hh:mm:ss a';
export const US_SHORT = 'MM/dd/yy hh:mm a';
export const US_COMPLETE = 'MM/dd/yyyy hh:mm a';
export const US_COMPLETE_WTZ = 'MM/dd/yyyy hh:mm a z';
export const US_SHORT_WS = 'MM/dd/yy hh:mm:ss a';
export const US_SHORT_SIMPLE = 'M/d/yy H:m';
export const TIMESTREAM_FORMAT = 'yyyy-MM-dd HH:mm:ss.SSSSSSSSS';
export const HISTORY_DATE_FORMAT = 'MM/DD/YYYY hh:mm';
export const DATE_FORMAT_AM_PM = 'MM/DD/YYYY hh:mm A';
export const HISTORY_DATE_FORMAT_24 = 'MM/DD/YYYY HH:mm';
export const HISTORY_DATE_ANDROID = 'YYYY-MM-DD H:mm';
export const MOBILE_CONVERSION_FORMAT = 'MM/DD/YY hh:mm:ss A';

export const isApplyDateFormat = date =>
  dayjs(date, US_LONG_AM_PM_UI).isValid();

export const setDateObject = date => dayjs(date).toDate();

export const getDayjs = (date = new Date()) => dayjs(date);

export const getDateWithCalendarFormat = (date, calendarFormat) =>
  dayjs(date).calendar(null, calendarFormat);

export const getDateUtc = (date = null) => (date ? dayjs(date) : dayjs());

export const getDayjsToJSDateInUTC = date => dayjs.utc(date).toDate();

//* *************************//
//* ********* UTC ***********//
//* *************************//

export const getUTC = date => {
  if (date) {
    try {
      const dateObj = dayjs(date);
      return {
        date: dateObj.format(formatDateToSave),
        dateUTC: dateObj.utc(),
        dateUTCFormat: dateObj.utc().format(formatDateToSave)
      };
    } catch (e) {
      return date;
    }
  }
  return {
    date: dayjs(new Date()).format(formatDateToSave),
    dateUTC: dayjs(new Date()).utc(),
    dateUTCFormat: dayjs(new Date()).utc().format(formatDateToSave)
  };
};

export const getDateJsWithoutTimezoneFromUTCString = dateUTCString => {
  if (typeof dateUTCString !== 'string' || !dateUTCString.endsWith('Z'))
    return null;

  const dateWithoutZ = new Date(dateUTCString.slice(0, -1));

  const tzoffset = new Date(dateWithoutZ).getTimezoneOffset() * 60000; //offset in milliseconds

  const dateStringWithoutTimezone = new Date(dateWithoutZ.valueOf() - tzoffset)
    .toISOString()
    .slice(0, -1);

  const dateJSWithoutTimezone = new Date(dateStringWithoutTimezone);

  return dateJSWithoutTimezone;
};

export const setDateToSave = date => dayjs(date).utc().format(formatDateToSave);

export const convertDateObjToUTC = date => dayjs(date).format(formatDateToSave);

export const toDateObjWithTZ = date => new Date(date);

export const setUTCToDatePickerView = (
  date = new Date(),
  format = HISTORY_DATE_FORMAT
) => dayjs(date).format(format);

export const customDateFormat = (format = formatDateToSave, isUtc = false) => {
  return isUtc ? dayjs().utc().format(format) : dayjs().format(format);
};

export const customDateFormatUS_SHORT = (format, isUtc = false) => {
  return isUtc
    ? dayjs().utc().format(US_SHORT)
    : dayjs().format(US_SHORT_SIMPLE);
};

export const setDateToInputCalendarViewUTC = ({ date = null }) =>
  dayjs(date).utc().format(US_LONG_AM_PM_UI);

export const getDateUtcFormat = (date = null) =>
  date ? dayjs(date).utc().format() : dayjs().utc().format();

export const getUtcFromHistory = date =>
  dayjs(date, HISTORY_DATE_FORMAT).utc().format(formatDateToSave);

/** US applyDateFormat `z` abbr → IANA. MST uses Phoenix for year-round MST. */
const US_TZ_ABBR_TO_IANA = {
  EST: 'America/New_York',
  EDT: 'America/New_York',
  CST: 'America/Chicago',
  CDT: 'America/Chicago',
  MST: 'America/Phoenix',
  MDT: 'America/Denver',
  PST: 'America/Los_Angeles',
  PDT: 'America/Los_Angeles',
  AKST: 'America/Anchorage',
  AKDT: 'America/Anchorage',
  HST: 'Pacific/Honolulu'
};

const UI_DATE_WITH_TZ_ABBR =
  /^(\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2} [AP]M)\s+([A-Z]{2,5})$/i;

/**
 * Converts an applyDateFormat UI date (`MM/DD/YYYY hh:mm:ss A z`) to UTC for
 * the API.
 *
 * Dayjs customParseFormat does not apply the `z` abbreviation when parsing —
 * it ignores values like `CDT`/`MST` and treats the wall clock as the device
 * timezone — so we map the abbr to an IANA zone and parse with `dayjs.tz`.
 * Unknown abbrs fall back to `DEFAULT_TIME_ZONE_LONG` (`America/Chicago`).
 *
 * @param {string} date - UI-formatted date from the API, or ISO/UTC string.
 * @returns {string} UTC timestamp in `formatDateToSave`.
 */
export const getDateToSave = date => {
  if (!date) return date;

  const dateStr = String(date).trim();
  const match = dateStr.match(UI_DATE_WITH_TZ_ABBR);

  if (match) {
    const [, wallClock, abbr] = match;
    const timeZone =
      US_TZ_ABBR_TO_IANA[abbr.toUpperCase()] || DEFAULT_TIME_ZONE_LONG;
    const parsed = dayjs.tz(wallClock, 'MM/DD/YYYY hh:mm:ss A', timeZone);

    if (parsed.isValid()) {
      return parsed.utc().format(formatDateToSave);
    }
  }

  const uiFormatted = dayjs(dateStr, US_LONG_AM_PM_UI);
  if (uiFormatted.isValid()) {
    return uiFormatted.utc().format(formatDateToSave);
  }

  return dayjs(dateStr).utc().format(formatDateToSave);
};

//* ************************* //
//* ****** TIMEZONES ******** //
//* ************************* //

export const convertUTCwithTimezoneToDateObj = (utcDate, timeZone) => {
  const applyTimezoneToUTC = getDateWithTimeZoneForMobile(
    utcDate,
    timeZone,
    {},
    true
  );
  const convertStringToDayjsObj = dayjs(
    applyTimezoneToUTC,
    MOBILE_CONVERSION_FORMAT
  );
  const convertDayjsToDate = convertStringToDayjsObj.toDate();
  return convertDayjsToDate;
};

export const getTimeZone = timeZone => {
  if (timeZone) {
    try {
      return {
        timeZone,
        abbr: dayjs().tz(timeZone).format(TIMEZONE_FORMAT)
      };
    } catch (e) {
      return {
        timeZone,
        abbr: ''
      };
    }
  }
  return {
    timeZone: dayjs.tz.guess(),
    abbr: dayjs().tz(dayjs.tz.guess()).format(TIMEZONE_FORMAT)
  };
};

export const getTimezoneAbbreviation = ({ timezone = dayjs.tz.guess() }) => {
  try {
    return dayjs().tz(timezone).format(TIMEZONE_FORMAT);
  } catch (e) {
    return dayjs().tz(dayjs.tz.guess()).format(TIMEZONE_FORMAT);
  }
};

export const getDateWithTimeZoneForMobile = (
  date = new Date(),
  timeZone = dayjs.tz.guess(),
  options = {},
  removeTz = false
) => {
  const opt = {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZoneName: 'short',
    timeZone,
    ...options
  };
  if (removeTz) {
    delete opt.timeZoneName;
  }
  try {
    return new Date(date).toLocaleString('en-US', opt)?.replace(/,/, '');
  } catch (e) {
    opt.timeZone = DEFAULT_TIME_ZONE;
    return new Date(date).toLocaleString('en-US', opt)?.replace(/,/, '');
  }
};

export const msToDuration = ms => {
  if (!ms || ms === 0) return '0d 00:00:00';

  const totalSeconds = Math.floor(ms / 1000);
  const days = Math.floor(totalSeconds / (24 * 3600));
  const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const pad = n => String(n).padStart(2, '0');

  return `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

export const setDateCalendarWithTZ = (date, wellSiteTz) => {
  try {
    return dayjs(
      dayjs(date).tz(wellSiteTz, true).format(formatDateToCalendar)
    ).toDate();
  } catch (e) {
    return dayjs(
      dayjs(new Date()).tz(dayjs.tz.guess()).format(formatDateToCalendar)
    ).toDate();
  }
};

export const setDateToCalendarWithTZ = ({
  date = new Date(),
  timezone = dayjs.tz.guess()
}) => {
  try {
    if (date) {
      return dayjs(
        dayjs(date).tz(timezone).format(formatDateToCalendar)
      ).toDate();
    }
    return dayjs(
      dayjs(new Date()).tz(timezone).format(formatDateToCalendar)
    ).toDate();
  } catch (e) {
    return dayjs(
      dayjs(new Date()).tz(dayjs.tz.guess()).format(formatDateToCalendar)
    ).toDate();
  }
};

/**
 * Formats a date for UI in the given timezone.
 * Defaults preserve legacy behavior for all existing callers (keepLocalTime=true, formatDateToView).
 * Pass keepLocalTime=false to convert a UTC/ISO instant into wellSiteTz.
 * @param {string|number|Date} date
 * @param {string} wellSiteTz IANA timezone (e.g. America/Chicago)
 * @param {boolean} [keepLocalTime=true] Legacy wall-clock keep; false = convert absolute instant
 * @param {string} [format=formatDateToView] Prefer existing format constants from this module
 * @returns {string}
 */
export const setDateViewWithTZ = (
  date,
  wellSiteTz,
  keepLocalTime = true,
  format = formatDateToView
) =>
  wellSiteTz
    ? dayjs(date).tz(wellSiteTz, keepLocalTime).format(format)
    : date;

export const getDateWithTimeZone = ({ date, timezone, timeZoneArgs = [] }) =>
  timeZoneArgs.length > 0
    ? dayjs(date).tz(timezone, ...timeZoneArgs)
    : dayjs(date).tz(timezone);

/**
 * Parses an ISO string in UTC and converts it to the given timezone using Intl.
 * Returns an object with .format(). Falls back to device timezone if the given one is invalid.
 */
export const getDateWithTimeZoneFromUTC = (isoDateString, timezone) => {
  const deviceTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const tz = timezone || deviceTz;
  const d = new Date(isoDateString);
  let parts;
  let tzParts;
  try {
    parts = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(d);
    tzParts = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      timeZoneName: 'short'
    }).formatToParts(d);
  } catch {
    parts = new Intl.DateTimeFormat('en-US', {
      timeZone: deviceTz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(d);
    tzParts = new Intl.DateTimeFormat('en-US', {
      timeZone: deviceTz,
      timeZoneName: 'short'
    }).formatToParts(d);
  }
  const get = (arr, type) => arr.find(p => p.type === type)?.value ?? '';
  const str = `${get(parts, 'month')}/${get(parts, 'day')}/${get(parts, 'year')} ${get(parts, 'hour')}:${get(parts, 'minute')}:${get(parts, 'second')} ${get(tzParts, 'timeZoneName') || tz}`;
  return { format: _fmt => str };
};

//* *************************//
//* ******** UTILS **********//
//* *************************//

export const isValidTimezone = timezone => {
  try {
    // Use the current date as the base date
    dayjs.tz(dayjs(), timezone);
    return true; // If no error, the timezone is valid
  } catch (error) {
    return false; // If error, the timezone is invalid
  }
};

export const getDateAsSeconds = ({ hours = 0, minutes = 0, seconds = 0 }) => {
  return dayjs.duration({ hours, minutes, seconds }).asSeconds();
};

export const setDateToInputCalendarViewSubstract = ({ substract = 2 }) =>
  dayjs().startOf('day').subtract(substract, 'day').format(US_LONG_AM_PM_UI);

export const getDateNowWithFormat = (format = US_LONG_AM_PM_UI) =>
  dayjs().format(format);

export const getStartOfMonthDate = (format = SHORT_YEAR_FORMAT_DATE) =>
  dayjs().startOf('month').format(format);

export const getMonthToDateRange = (format = SHORT_YEAR_FORMAT_DATE) => ({
  start: getStartOfMonthDate(format),
  end: getDateNowWithFormat(format)
});

export const subtractDate = (value, type) => dayjs().subtract(value, type);

export const addDate = (value, type) => dayjs().add(value, type);

export const getDateHour = date => dayjs(date).format(formatRegularHour);

export const getAmPmMarket = date => dayjs(date).format(AMPM);

export const getHoursMinutes = date => {
  if (!isApplyDateFormat(date)) return date;
  return dayjs(date, US_LONG_AM_PM_UI).format(HOURS_MINUTES);
};

export const getCalendarMonthYearFormat = date => {
  if (!isApplyDateFormat(date)) return date;
  const month = dayjs(date, US_LONG_AM_PM_UI).format(MONTH_NAME_ABBREVIATED);
  const day = dayjs(date, US_LONG_AM_PM_UI).format(DAY_WITH_ORDINAL);
  const year = dayjs(date, US_LONG_AM_PM_UI).format(FOUR_DIGIT_YEAR);
  return `${month} ${day} ${year}`;
};

export const getSecondsFormattedInDDHHMMSS = seconds => {
  if (!seconds || typeof seconds !== 'number' || seconds <= 0)
    return '00:00:00';

  // Calculate days, hours, minutes, and seconds
  const days = Math.floor(seconds / (3600 * 24));
  const hours = Math.floor((seconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // Format days, hours, minutes, and seconds with leading zeroes if necessary
  const formattedDays = String(days).padStart(1, '0');
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(remainingSeconds).padStart(2, '0');

  // Combine formatted hours, minutes, and seconds with colons
  return `${
    days ? `${formattedDays}d ` : ' '
  }${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const getDifference = (dateStart, dateEnd, type) => {
  const date1 =
    typeof dateStart === 'string'
      ? dayjs(dateStart, HISTORY_DATE_FORMAT)
      : dateStart;
  const date2 =
    typeof dateEnd === 'string' ? dayjs(dateEnd, HISTORY_DATE_FORMAT) : dateEnd;
  return date1.diff(date2, type, true);
};

//* *************************//
//* ******** FORMAT *********//
//* *************************//

export const getDateCustomFormatIn = (date, customFormatIn) =>
  dayjs(date, customFormatIn);

export const getDateCustomFormatOut = (date, customFormatOut) =>
  dayjs(date).format(customFormatOut);

export const getDateCustomFormat = (date, customFormatIn, customFormatOut) =>
  dayjs(date, customFormatIn).format(customFormatOut);

export const setDateToInputCalendarView = date =>
  dayjs(date).format(US_LONG_AM_PM_UI);

export const getDateHistoryFormat = date =>
  dayjs(date).format(HISTORY_DATE_FORMAT);

export const getDateHistoryFormat24 = date =>
  dayjs(date).format(HISTORY_DATE_FORMAT_24);

export const getAndroidHistoryFormat = date => {
  return date
    ? dayjs(date, HISTORY_DATE_FORMAT).format(HISTORY_DATE_ANDROID)
    : dayjs().format(HISTORY_DATE_ANDROID);
};

export const getIosHistoryFormat = date => {
  return dayjs(date, HISTORY_DATE_FORMAT);
};

export const getDate = date => dayjs(date).format(formatDate);

export const setFormatDateToView = date => {
  if (!isApplyDateFormat(date)) return date;
  return dayjs(date, US_LONG_AM_PM_UI).format(US_LONG_AM_PM_UI);
};

export const getShortUSFormatDate = date => {
  if (!isApplyDateFormat(date)) return date;
  return dayjs(date, US_LONG_AM_PM_UI).format(SHORT_YEAR_FORMAT_DATE_US);
};

export const getShortUSDate = date => {
  return dayjs(date).format(SHORT_YEAR_FORMAT_DATE_US);
};

export const getShortUSFormatDateYearInit = date => {
  if (!isApplyDateFormat(date)) return date;
  return dayjs(date, US_LONG_AM_PM_UI).format(SHORT_YEAR_FORMAT_DATE);
};

export const getShortFormatTime = date => {
  if (!isApplyDateFormat(date)) return date;
  return dayjs(date, US_LONG_AM_PM_UI).format(REGULAR_HOUR);
};

export const getDayMonthFromUTC = date => {
  return dayjs(date).format(DAY_MONTH);
};

export const getMonthDayFromUTC = date => {
  return dayjs(date).format(MONTH_DAY);
};

export const getMonthYearFromUTC = date => {
  return dayjs(date).format(MONTH_YEAR);
};

export const getRegularHourFromUTC = date => {
  return dayjs(date).format(formatRegularHour);
};

export const getDateForCalendarInput = date =>
  dayjs(date, US_LONG_AM_PM_UI).format(formatDateToCalendar);

export const getDateForCalendarView = date =>
  dayjs(date, US_LONG_AM_PM_UI).format(HISTORY_DATE_FORMAT);

export const getDateForCustomFormat = date =>
  isApplyDateFormat(date)
    ? dayjs(date, US_LONG_AM_PM_UI).format(CUSTOM_DATE_FORMAT)
    : dayjs(date).format(CUSTOM_DATE_FORMAT);

export const getUtcCUstomFormat = (
  date,
  formatIn = SHORT_DATE_AMPM,
  formatOut = formatDateToSave
) => {
  const result = dayjs(date, formatIn).utc().format(formatOut);
  if (dayjs(result).isValid()) {
    return result;
  }
  return dayjs().utc().format(formatOut);
};

export const getTimeZoneShort = (timeZone = dayjs.tz.guess()) => {
  let formatTz;
  try {
    formatTz = dayjs.tz(dayjs().utc().format(formatDateToSave), timeZone);
  } catch (e) {
    formatTz = dayjs.tz(
      dayjs().utc().format(formatDateToSave),
      dayjs.tz.guess()
    );
  }
  return formatTz.format('z');
};
export const getDateCustomInFormatTz = (date, customFormatIn, timeZone) => {
  const tz = isValidTimezone(timeZone) ? timeZone : DEFAULT_TIME_ZONE;

  return dayjs.tz(dayjs(date, customFormatIn).format(formatDateToSave), tz);
};
export const getDateCustomFormatTz = ({
  date,
  customFormatIn = US_COMPLETE_A,
  customFormatOut = US_LONG_AM_PM_UI,
  timeZone = DEFAULT_TIME_ZONE_LONG
}) => {
  return dayjs
    .tz(dayjs(date, customFormatIn).format(formatDateToSave), timeZone)
    .format(customFormatOut);
};

export const getMilisecondsToDate = milliseconds => {
  return dayjs(milliseconds * 1000).format();
};

export const getMilisecondsFromCurrentDate = (date = new Date()) => {
  return dayjs(date).unix();
};

export const addMinutes = (date, minutes) => {
  return dayjs(date).add(minutes, 'minute').format();
};

export const getDateNowFormatted = date => {
  return dayjs(date).format();
};

export const addMiliseconds = (date, miliseconds) => {
  return dayjs(date).add(miliseconds, 'millisecond').format(US_LONG_AM_PM_UI);
};

export const convertToDayJsObj = date => {
  return dayjs(date, US_LONG_AM_PM_UI).toDate();
};

export const isDateWithinThreshold = (
  date,
  threshold = 15,
  unit = 'minute',
  timeZone = 'UTC'
) => {
  if (!date) return false;
  const pastDate = dayjs.tz(date, timeZone);
  const now = dayjs.tz(dayjs(), timeZone);
  return now.diff(pastDate, unit) <= threshold;
};

export const formatToDateTimeLocal = dateString => {
  if (!dateString) return '';
  const withFormat = dayjs(dateString, US_LONG_AM_PM_UI);
  if (withFormat.isValid()) return withFormat.format('YYYY-MM-DDTHH:mm');
  return dayjs(dateString).format('YYYY-MM-DDTHH:mm');
};

export const formatToISO = dateTimeLocal => {
  if (!dateTimeLocal) return '';
  return dayjs(dateTimeLocal).toISOString();
};

export const formatDateForDisplay = dateString => {
  if (!dateString) return '';
  try {
    return dayjs(dateString).format(US_SHORT_DATETIME_DISPLAY);
  } catch {
    return dateString;
  }
};

/**
 * Read-only label for HTML date values: strict `YYYY-MM-DD` as local calendar
 * day, else dayjs parse. Returns `MM/DD/YYYY`, or the original string if invalid.
 */
export const formatDateInputValueForReadOnly = dateValue => {
  if (dateValue == null || String(dateValue).trim() === '') return '';
  const trimmed = String(dateValue).trim();
  let parsed = dayjs(trimmed, SHORT_YEAR_FORMAT_DATE, true);
  if (!parsed.isValid()) parsed = dayjs(trimmed);
  if (!parsed.isValid()) return dateValue;
  return parsed.format(formatDate);
};

/**
 * Converts API `startDate`  to a `YYYY-MM-DD` string.
 */
export const apiDateToFormDateValue = value => {
  if (value == null || String(value).trim() === '') return '';
  const trimmed = String(value).trim();
  if (dayjs(trimmed, SHORT_YEAR_FORMAT_DATE, true).isValid()) return trimmed;
  const parsed = dayjs.utc(trimmed);
  return parsed.isValid() ? parsed.format(SHORT_YEAR_FORMAT_DATE) : '';
};

const HISTORY_UI_WALL_CLOCK_FORMAT = 'MM/DD/YYYY hh:mm:ss A';
const HISTORY_DATETIME_LOCAL_FORMAT = 'YYYY-MM-DDTHH:mm';
const HISTORY_TZ_ABBR_SUFFIX = /\s+[A-Z]{2,5}$/i;

const stripHistoryTimezoneAbbr = date =>
  String(date).trim().replace(HISTORY_TZ_ABBR_SUFFIX, '');

/**
 * Parses history UI dates (`MM/DD/YYYY hh:mm:ss A z`) or datetime-local
 * values without UTC round-trips that can flip AM/PM.
 */
export const parseHistoryUiDate = date => {
  const dateStr = String(date ?? '').trim();
  if (!dateStr) return dayjs(NaN);

  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(dateStr)) {
    const dateTimeLocal = dayjs(dateStr);
    if (dateTimeLocal.isValid()) return dateTimeLocal;
  }

  const wallClock = stripHistoryTimezoneAbbr(dateStr);
  const parsed = dayjs(wallClock, HISTORY_UI_WALL_CLOCK_FORMAT);
  if (parsed.isValid()) return parsed;

  return dayjs(dateStr);
};

export const formatHistoryUiDate = date => {
  const parsed =
    date && typeof date === 'object' && typeof date.format === 'function'
      ? date
      : parseHistoryUiDate(date);
  return parsed.format(US_LONG_AM_PM_UI);
};

export const formatHistoryDateTimeLocal = date => {
  if (!date) return '';
  const parsed = parseHistoryUiDate(date);
  if (!parsed.isValid()) return '';
  return parsed.format(HISTORY_DATETIME_LOCAL_FORMAT);
};

export const shiftHistoryUiDate = (date, miliseconds) =>
  formatHistoryUiDate(parseHistoryUiDate(date).add(miliseconds, 'millisecond'));

export const isHistoryUiDateBefore = (startDate, endDate) => {
  const start = parseHistoryUiDate(startDate);
  const end = parseHistoryUiDate(endDate);
  return start.isValid() && end.isValid() && start.isBefore(end);
};

export const diffHistoryUiDatesMillis = (startDate, endDate) =>
  parseHistoryUiDate(endDate).diff(parseHistoryUiDate(startDate));

export const isNowAfterHistoryUiDate = date => {
  const parsed = parseHistoryUiDate(date);
  return parsed.isValid() && getDayjs().isAfter(parsed.toDate());
};
